import { post, get } from '@/utils/network';

export default new class AdManageApi {
    //获取推荐的广告列表
    getRecommendAdList(params: { change: string, maxShowCount:number, recommendtype:number}) {
        return post('Paycourse/Ad/getRecommendAdList', params)
    }
    //获取推广的分类
    getCategoryLists() {
        return post('Paycourse/Ad/getCategoryLists')
    }
    //收集广告的曝光和点击日志
    collectAdLog(params: { adid: any, corpid: string, type: number, location:number}){
        return post('Paycourse/Ad/collectAdLog', params)
    }
    //收集首页的点击日志
    collectPageLog(params: {location:number}){
        return post('Paycourse/Ad/collectPageLog', params)
    }
    //获取首页数据
    getIndexData(params:{preview:string}){
        return post('Paycourse/Ad/getIndexData',params)
    }
    //获取某个分类的内容列表
    getCategoryContent(params: { categoryid: string, maxShowCount:number,preview:string,recommend:number}){
        return post('Paycourse/Ad/getCategoryContent',params)
    }
    //分页模式来获取某个分类下的内容列表
    getCategoryContentPage(params: { categoryid: string, page:number, limit:number}){
        return post('Paycourse/Ad/getCategoryContentPage',params)
    }
    //获取某个位置的广告
    getAdByLocation(params: { location: number, maxShowCount:number}){
        return post('Paycourse/Ad/getAdByLocation',params)
    }
    //搜索
    search(params: { title: string}){
        return post('Paycourse/Ad/search',params)
    }
}
